var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { getVisibleBanner, getBannerHandlers } from './store/selectors';
import { Banner } from '../components/banner';
import { createShareBannerConfig, createAutomatedCampaignBannerConfig } from './engage-banner-configs';
import { BannerType } from './types';
export var EngageBannerRenderer = function () {
    var visibleBanner = useSelector(getVisibleBanner);
    var handlers = useSelector(getBannerHandlers);
    if (!visibleBanner || !handlers[visibleBanner]) {
        return null;
    }
    var bannerHandlers = handlers[visibleBanner];
    var createBannerConfig = function () {
        switch (visibleBanner) {
            case BannerType.Share:
                return createShareBannerConfig(bannerHandlers.onPrimaryClick, bannerHandlers.onClose);
            case BannerType.AutomatedCampaign:
                return createAutomatedCampaignBannerConfig(bannerHandlers.onPrimaryClick, bannerHandlers.onClose);
            default:
                return null;
        }
    };
    var bannerConfig = createBannerConfig();
    if (!bannerConfig)
        return null;
    return _jsx(Banner, __assign({}, bannerConfig.bannerProps));
};
